import type {
  GetWhatsAppContactsInput,
  WhatsAppContactCreateDto,
  WhatsAppContactDto,
  WhatsAppContactUpdateDto,
} from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { AppFileDescriptorDto, DownloadTokenResultDto, GetFileInput } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class WhatsAppContactService {
  apiName = 'Default';

  create = (input: WhatsAppContactCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WhatsAppContactDto>(
      {
        method: 'POST',
        url: '/api/app/whats-app-contacts',
        body: input,
      },
      { apiName: this.apiName, ...config },
    );

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>(
      {
        method: 'DELETE',
        url: `/api/app/whats-app-contacts/${id}`,
      },
      { apiName: this.apiName, ...config },
    );

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WhatsAppContactDto>(
      {
        method: 'GET',
        url: `/api/app/whats-app-contacts/${id}`,
      },
      { apiName: this.apiName, ...config },
    );

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>(
      {
        method: 'GET',
        url: '/api/app/whats-app-contacts/download-token',
      },
      { apiName: this.apiName, ...config },
    );

  getFile = (input: GetFileInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>(
      {
        method: 'GET',
        responseType: 'blob',
        url: '/api/app/whats-app-contacts/file',
        params: { downloadToken: input.downloadToken, fileId: input.fileId },
      },
      { apiName: this.apiName, ...config },
    );

  getList = (input: GetWhatsAppContactsInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<WhatsAppContactDto>>(
      {
        method: 'GET',
        url: '/api/app/whats-app-contacts',
        params: {
          filterText: input.filterText,
          sorting: input.sorting,
          skipCount: input.skipCount,
          maxResultCount: input.maxResultCount,
          contato1: input.contato1,
          contato2: input.contato2,
          contato3: input.contato3,
          contato4: input.contato4,
          contato5: input.contato5,
        },
      },
      { apiName: this.apiName, ...config },
    );

  update = (id: string, input: WhatsAppContactUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WhatsAppContactDto>(
      {
        method: 'PUT',
        url: `/api/app/whats-app-contacts/${id}`,
        body: input,
      },
      { apiName: this.apiName, ...config },
    );

  uploadFile = (input: FormData, config?: Partial<Rest.Config>) =>
    this.restService.request<any, AppFileDescriptorDto>(
      {
        method: 'POST',
        url: '/api/app/whats-app-contacts/upload-file',
        body: input,
      },
      { apiName: this.apiName, ...config },
    );

  constructor(private restService: RestService) {}
}
